import { render, staticRenderFns } from "./SalarieIndex.vue?vue&type=template&id=e0d4a7b2&scoped=true"
import script from "./SalarieIndex.vue?vue&type=script&lang=js"
export * from "./SalarieIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d4a7b2",
  null
  
)

export default component.exports